import { defineMessages } from 'react-intl';

export default defineMessages({
    billingSummaryTabs: {
        id: 'ent.billing.billing-summary-page.Payment Center',
        defaultMessage: 'Payment Center',
    },
    failedToLoadPolices: {
        id: 'ent.billing.billing-summary.Failed to load polices',
        defaultMessage: 'Failed to load polices',
    },
    sorryWeCanNotLoadYourPolicyInformationAtThisTime: {
        id: 'ent.billing.billing-summary.Sorry we can not load your policy information at this time',
        defaultMessage:
            'Sorry we can not load your policy information at this time',
    },
    noBillingData: {
        id: 'ent.billing.billing-summary.no billing data',
        defaultMessage: 'No billing data available until there is an issued policy.',
    },
    managePaymentMethods: {
        id: 'ent.billing.billing-summary.Manage Payment Methods',
        defaultMessage: 'Manage Payment Methods',
    },
    duplicatePaymentDetected:{
        id: 'ent.billing.billing-summary.Duplicate Payment Detected',
        defaultMessage: 'Duplicate Payment Detected',
    },
    overPayment: {
        id: 'ent.billing.billing-summary.Payment cannot be more than the sum of selected invoices',
        defaultMessage: 'Payment cannot be more than the sum of selected invoices.'
    },
    paymentMoreThanPremium: {
         id: 'ent.billing.billing-summary.Payment cannot be more than Total Premium',
        defaultMessage: 'Payment cannot be more than Total Premium.'
    }

});
